import api from '../api';
import { LOGOUT_SUCCESS } from '../actions/logout';

const MENU_LIST = api.events.menuList.actionSuccess;

const defaultState = { list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case MENU_LIST:
      return { ...state, list: action.data };
    case LOGOUT_SUCCESS:
      return defaultState;
    default:
      return state;
  }
};
